import React, { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import JsPDF from "jspdf";
import { Row, Modal, Form } from "reactstrap";

// canvas
import SignatureCanvas from "react-signature-canvas";

// images
import zithasLogo from "../../assets/images/zithas-dark-logo.png";
import sign from "../../assets/images/signature.png";
import axios from "axios";
import Loader from "pages/Separate/Loader";
import moment from "moment";
import configure from "configure";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";
import { onDownloadPdf } from "utils/common-helpers";

const EditDocument = () => {
  const [fixedRightSec, setFixedRightSec] = useState(false);
  const [modal_center, setmodal_center] = useState(false);
  const [attachmentModal, setAttachmentModal] = useState(false);

  document.addEventListener("scroll", () => {
    if (window.scrollY > 48) {
      setFixedRightSec(true);
    } else {
      setFixedRightSec(false);
    }
  });

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
  });

  function addNoBreakInline(html) {
    html = html
      .replace(
        /<p([^>]*)>/g,
        `<p$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<li([^>]*)>/g,
        `<li$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<ul([^>]*)>/g,
        `<ul$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<ol([^>]*)>/g,
        `<ol$1 style="page-break-inside: avoid; break-inside: avoid;">`
      )
      .replace(
        /<div([^>]*)>/g,
        `<div$1 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;">`
      )
      .replace(
        /<h([1-4])([^>]*)>/g,
        `<h$1$2 style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;">`
      );

    html = html.replace(
      /<table([^>]*)>/g,
      `<div style="page-break-inside: avoid; break-inside: avoid; padding-top: 30px;"><table$1>`
    );

    html = html.replace(/<\/table>/g, `</table></div>`);

    return html;
  }

  // const onDownload = () => {
  //     setLoading(true);
  
  //     setTimeout(() => {
  //       const content = contentRef.current;
  
  //       const opt = {
  //         filename: `${"Document"}.pdf`,
  //         image: { type: "jpeg", quality: 0.98 },
  //         html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
  //         jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
  //       };
  
  //       html2pdf()
  //         .from(content)
  //         .set(opt)
  //         .save()
  //         .finally(() => {
  //           setLoading(false);
  //         });
  //     }, 150);
  //   };

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: "Letter",
    removeAfterPrint: true,
    pageStyle: `
      @page { 
        size: A4; 
        margin: 0.5in; 
      }
      @media print {
        body { -webkit-print-color-adjust: exact; }
        #printableLetter {
          padding: 40px 70px !important;
        }
        .text-center img {
          height: 80px !important;
        }
      }
    `,
  });
  const params = useParams();
  const [isLoading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [date, setDate] = useState("");
  const [company_name, setCompnayName] = useState("");
  const [expire, setExpire] = useState();
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [note, setNote] = useState("");
  const [symbol, setCurrencySymbol] = useState("");
  const [contract_type, setContractType] = useState([]);
  const [contract_value, setContractValue] = useState("");
  const [signature, setSignature] = useState(null);

  const [attachment, setAttachment] = useState("");

  useEffect(() => {
    fetchContract();
  }, []);

  const fetchContract = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("junk_link", params.id);
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/showStaffLetter`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then((response) => {
        console.log("responxcsdcsdse: ", response?.data?.data);
        console.log(
          "response.data.success: ",
          response.data.success,
          "response.data.signature: ",
          response.data.data.signature,
          "comparisn: ",
          response.data.success == true && response.data.signature == null
        );
        setExpire(false);
        setSignature(response?.data?.data?.signature);
        const htmlRaw = response?.data?.data?.final_template;
        let cleanHTML = htmlRaw
          .replaceAll("{", "")
          .replaceAll("}", "")
        const processed = addNoBreakInline(cleanHTML);
        setDescription(processed);
        setDate(response.data?.data?.created_at);
        setLetterId(response.data.data.staff_letter_id);
        setLetterType(response.data.data.requirement_type);
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [letter_id, setLetterId] = useState("");
  const [letterType, setLetterType] = useState("");

  const signatureRef = useRef(null);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
      Swal.fire({
        icon: "warning",
        text: "Please Sign the letter",
      });
      return;
    }
    const signatureImage = signatureRef.current.toDataURL();
    setLoading(true);
    const formData = new FormData();
    formData.append("letter_id", letter_id);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("signature", signatureImage);
    try {
      console.log("calling api");
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/signLetter`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("api called: ", response);
      console.log(response);
      if (response.data.success == true) {
        console.log("response", response);
        Swal.fire({
          icon: "success",
          text: `Thanks For signing ${letterType}`,
        }).then((data) => {
          setmodal_center(false);
          window.location.reload();
        });
      } else {
        console.log(response);
        Swal.fire({
          icon: "warning",
          text: "Please Enter Same Name and Email Address",
        }).then((data) => {});
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      Swal.fire({
        icon: "warning",
        text: "Please Enter Same Name and Email Address",
      }).then((data) => {});
    }
  };
  const handleClear = () => {
    signatureRef.current.clear();
  };

  const handleAttachmentSave = async (e) => {
    e.preventDefault();
    if (attachment?.length > 0) {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("letter_id", letter_id);
        formData.append("name", name);
        formData.append("email", email);
        formData.append("signature", attachment);

        const response = await axios.post(
          `${configure.nodeApi}/contract/save_contract`,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setLoading(false);
        if (response.data.success == true) {
          Swal.fire("", "Thanks For signining Letter", "success");
          setName("");
          setEmail("");
          setAttachmentModal(false);
        }

        // console.log("response", response.data)
      } catch (error) {
        console.log(error);
        setLoading(false);
        Swal.fire("", "Something went wrong!", "error");
      }
    }
  };

  const handleToBase24 = (e) => {
    if (
      e.target.files[0].type == "image/jpeg" ||
      e.target.files[0].type == "image/png"
    ) {
      const image_data = new FileReader();
      image_data.addEventListener("load", () => {
        setAttachment(image_data.result);
      });
      image_data.readAsDataURL(e.target.files[0]);
    } else {
      Swal.fire("", "Only JPG and PNG images can upload!", "warning");
    }
  };

  if (expire == false) {
    return (
      <React.Fragment>
        {console.log("expire == false")}
        {isLoading && <Loader />}
        <div className="page-content mb-2" style={{ paddingTop: "60px" }}>
          <Container fluid>
            <Row>
              <div className="col-md-9 col-12 ps-md-0 order-md-1 order-2 mt-4">
                <div
                  className="bg-white shadow document"
                  ref={contentRef}
                  id="printableLetter"
                  style={{
                    paddingLeft: "120px",
                    paddingRight: "120px",
                    paddingTop: "30px",
                    paddingBottom: "50px",
                  }}
                >
                  <div
                    className="text-center"
                    style={{ marginBottom: "20px", paddingTop: "20px" }}
                  >
                    <img
                      src={zithasLogo}
                      height="80"
                      alt="zithasLogo"
                      style={{ maxHeight: "80px" }}
                    />
                  </div>
                  <div>
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: description
                            .replaceAll("{", "")
                            .replaceAll("}", ""),
                        }}
                      />
                    </div>

                    <h5 className="fw-bold text-decoration-underline">
                      Date : {moment(date).format("DD-MM-YYYY")}
                    </h5>

                    <Row className="mt-4 d-flex justify-content-between ">
                      <div className="col-6">
                        {signature == null ? (
                          <div className="sign-box">Signature</div>
                        ) : (
                          <img src={sign} height="50" className="mb-2" />
                        )}
                        <h5>Zithas Signature</h5>
                      </div>

                      <div className="col-6 text-end">
                        {signature ? (
                          <>
                            <img src={signature} height="50" className="mb-2" />
                            <h5
                              className="mr-4 "
                              style={{ marginRight: "40px" }}
                            >
                              {name || "Signature"}
                            </h5>
                          </>
                        ) : null}
                      </div>
                    </Row>
                  </div>
                </div>
              </div>

              <div className="col-md-3 col-12 pe-md-0 order-md-2 order-1 mb-md-0 mb-3 mt-4">
                <div
                  className={`${
                    fixedRightSec ? "fixed-right-section top-0 " : ""
                  }`}
                >
                  {/* buttons */}
                  <div className="d-flex col-12 text-xl-start text-center justify-content-center">
                    {/* Print Button */}
                    <button
                      onClick={() => handlePrint()}
                      className="btn btn-sm btn-success border-radius me-1"
                      disabled={signature == null} // 🔥 disable when no signature
                    >
                      <i className="fas fa-print me-1"></i> Print
                    </button>

                    {/* Signature Button */}
                    <button
                      onClick={() => setmodal_center(true)}
                      className="btn btn-sm btn-primary border-radius me-1"
                      disabled={signature != null} // 🔥 disable when signature exists
                    >
                      <i className="fas fa-file-signature me-1"></i> Signature
                    </button>

                    {/* Download Button */}
                    <button
                      onClick={() => onDownloadPdf(setLoading, contentRef, letterType)}
                      className="btn btn-sm btn-secondary border-radius"
                      disabled={signature == null} // 🔥 disable when no signature
                    >
                      <i className="fas fa-file-download me-1"></i> Download
                    </button>
                  </div>

                  {/* contract data */}
                  {/* <div className="bg-white p-3 mt-4 shadow">
                    <h6 className="mb-3">
                      Start Date: {moment(start_date).format("DD-MM-YYYY")}
                    </h6>
                    <h6 className="mb-3">Letter Type: {contract_type}</h6>
                    <h6>Note: {note}</h6>
                  </div> */}

                  {/* <div className="bg-white p-3 mt-4 shadow ">
                    <p className="text-danger">
                      * If you encounter any issues while signing the contract
                      please sign on a piece of paper and scan the signature
                      then upload the scan here.
                    </p>

                    <div>
                      <label htmlFor="">Attachment</label>

                      <div>
                        <button
                          onClick={() => setAttachmentModal(true)}
                          className="btn btn-sm btn-primary border-radius py-2 w-100"
                        >
                          <i className="fas fa-file-signature me-1"></i> Attach
                          Your Signature
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </Row>
          </Container>
        </div>

        {/* Signature Modal */}
        <Modal
          isOpen={modal_center}
          toggle={() => {
            tog_center();
          }}
          centered
          size="lg"
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              Signature & Confirmation Of Identity
            </h5>
            <button
              type="button"
              onClick={() => {
                setmodal_center(false);
              }}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleSave}>
              <Row>
                <div className="col-md-5 mb-3">
                  <label htmlFor="">Name</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control "
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-5 mb-3">
                  <label htmlFor="">Personal Email Address </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="">Signature</label>
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                      // width: 760,
                      // height: 300,
                      className: "sigCanvas border w-100 signatureHeight",
                    }}
                    ref={signatureRef}
                  />
                </div>
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <a className="btn btn-red btn-label me-2" onClick={handleClear}>
                  <i className="bi bi-x-circle label-icon"></i>
                  Clear Signature
                </a>
                <button className="btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
        {/* ------------ */}

        {/* Attachment Modal */}
        <Modal isOpen={attachmentModal} centered size="md">
          <div className="modal-header">
            <h5 className="modal-title mt-0">Attach Your Signature</h5>
            <button
              type="button"
              onClick={() => {
                setAttachmentModal(false);
              }}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleAttachmentSave}>
              <Row>
                <div className="col-md-6 mb-3">
                  <label htmlFor="">Name</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="">Email Address </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="">Signature Attachment</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handleToBase24}
                  />
                </div>

                {attachment && (
                  <div>
                    <img src={attachment} alt="" height={"80px"} />
                  </div>
                )}
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <button className="btn btn-save btn-label" type="submit">
                  <i className="fas fa-save me-2 label-icon"></i>
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
        {/* ------------ */}
      </React.Fragment>
    );
  } else if (expire == true) {
    console.log("expire == true");
    return (
      <section className="my-5 pt-sm-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center col">
              <div className="home-wrapper">
                <div className="mb-5">
                  <a
                    className="d-block auth-logo"
                    href={`${configure.appUrl}dashboard`}
                  ></a>
                </div>
                <div className="justify-content-center row">
                  <div className="col-sm-4">
                    <div className="maintenance-img">
                      <img
                        src="/static/media/maintenance.938d28ce46a03edf5d9303e67f1d2028.svg"
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <img src={zithasLogo} className="" height="100" />
                </div>
                <h1 className="pt-5">Thanks For signing {letterType}</h1>
                <h5 className="mt-2">We'll get in contact with you shortly </h5>

                {/* <div className="mt-5">
                  <button
                    className="border-radius btn text-white me-2 btn-purple"
                    onClick={() => window.close()}
                  >
                    <i className="dripicons-cross me-2 icon-center"></i>Close
                    Browser Tab
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    console.log("else portion");
    return <Loader />;
  }
};

export default EditDocument;
